module.exports = __webpack_public_path__ + "img/correct.71cc219d.png";